<template>
  <div>
    <div class="bg-fff pa-t-16 pa-r-20 pa-b-20 width920px user-message">
      <div class="titles-right font-style">特约摄影师</div>

      <!-- 已经申请加入 -->
      <div v-if="detail.IsJoin">
        <div class="flex f-between">
          <div>
            <div class="ma-t-10">姓名：{{ detail.Name }}</div>
            <div class="ma-t-10">手机：{{ detail.Phone }}</div>
            <div class="ma-t-10">状态：{{ detail.Status }}</div>
            <div class="ma-t-10" v-if="['已认证'].includes(detail.Status)">有效期：{{ detail.StartTime }} - {{ detail.EndTime }}</div>
            <div class="ma-t-40">
              <div
                class="btn-red c-p"
                v-if="['已过期'].includes(detail.Status)"
                @click="ToPayRenew()"
              >
                延长认证时间
              </div>
              <div
                class="btn-red c-p"
                v-if="['待支付'].includes(detail.Status)"
                @click="ToPay()"
              >
                支付费用
              </div>
            </div>
          </div>
          <div v-if="['已过期', '已认证'].includes(detail.Status)" class="width28 t-center">
            <div class="pa-b-10">
              <img
              src="../img/Photographer/20220317184239.png"
              alt=""
              srcset=""
              width="80%"
            />
            </div>
            <a style="text-decoration: none;" href="https://weiting-develop.oss-cn-shanghai.aliyuncs.com/img/47fae2d7-0744-4f8c-bafd-78a7fd418a3e_24823.png?response-content-type=application/octet-stream" download>下载桂冠</a>
            <div class="bg-fb004d ma-t-20 ma-b-10 pa-b-10">
              <img
              src="../img/Photographer/20230417144216.png"
              alt=""
              srcset=""
              width="80%"
            />
            </div>
            <a style="text-decoration: none;" href="https://weiting-develop.oss-cn-shanghai.aliyuncs.com/img/33bdcee5-ed6f-4b92-bb06-4b475d487469_97404.png?response-content-type=application/octet-stream" download>下载桂冠</a>

          </div>
        </div>
      </div>

      <!-- 未申请加入 -->
      <div v-if="!detail.IsJoin">
        <div class="ma-t-40">
          <div class="t-center fon-26 width100">服务特权</div>
          <div class="ma-t-20 width100 t-center">
            翠麟创作人社区权益&《摄影与摄像》杂志权益
          </div>
          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s31.png" alt="" srcset="" />
              <div class="pa-tb-10">精英人才库</div>
              <div class="c-666">
                邀请加入翠麟影像精英人才库，获得SHISW官网推荐与宣传
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s32.png" alt="" srcset="" />
              <div class="pa-tb-10">专属微信群</div>
              <div class="c-666">
                邀请加入“特约摄像师”俱乐部社区（微信群），扩展人脉，结识好友
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s33.png" alt="" srcset="" />
              <div class="pa-tb-10">短片奖评选</div>
              <div class="c-666">优秀作品将受邀参加SHISW翠麟国际短片奖评选</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s34.png" alt="" srcset="" />
              <div class="pa-tb-10">展映交流活动</div>
              <div class="c-666">
                优秀作品邀请参加SHISW相关主题展映交流活动（线上/线下）
              </div>
            </div>
          </div>

          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s35.png" alt="" srcset="" />
              <div class="pa-tb-10">作品销售代理</div>
              <div class="c-666">优秀作品将获得国际销售代理</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s36.png" alt="" srcset="" />
              <div class="pa-tb-10">工作推荐</div>
              <div class="c-666">优秀作者奖获得相关工作经纪/推荐的机会</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s37.png" alt="" srcset="" />
              <div class="pa-tb-10">专属证书</div>
              <div class="c-666">
                获得《摄影与摄像》杂志颁发的“特约摄像师”证书，即获得杂志“特约摄像师”的专业身份
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s38.png" alt="" srcset="" />
              <div class="pa-tb-10">免费登载作品</div>
              <div class="c-666">
                《摄影与摄像》杂志官网与官方公众号平台，不定期免费登载作品
              </div>
            </div>
          </div>

          <div class="flex f-between ma-t-20">
            <div class="width20 t-center">
              <img src="../img/Photographer/s39.png" alt="" srcset="" />
              <div class="pa-tb-10">首席特约摄像师</div>
              <div class="c-666">
                每年将从“特约摄像师”中评选出《摄影与摄像》“首席特约摄像师”，并颁发证书，获得相应权益
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s40.png" alt="" srcset="" />
              <div class="pa-tb-10">协会会员</div>
              <div class="c-666">
                优秀者将邀请加入中国科教电影电视协会影像活动专业委员会成为会员
              </div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s41.png" alt="" srcset="" />
              <div class="pa-tb-10">优惠作品刊登</div>
              <div class="c-666">杂志刊登版面（图/文广告宣传）获8.8折</div>
            </div>
            <div class="width20 t-center">
              <img src="../img/Photographer/s42.png" alt="" srcset="" />
              <div class="pa-tb-10">获得翠麟荣誉桂冠</div>
              <div class="c-666">用于作品标识与展示</div>
            </div>
          </div>
        </div>
        <div class="flex f-jcenter ma-t-20">
          <div
            class="btn-red c-p ma-r-20"
            @click="$router.push({ path: '/photographer' })"
          >
            更多介绍
          </div>
          <div class="btn-red c-p ma-l-20" @click="dialogVisibleApply = true">
            申请加入
          </div>
        </div>
      </div>
    </div>

    <!-- 报名弹框 -->
    <el-dialog
      title="申请加入"
      center
      :visible.sync="dialogVisibleApply"
      @close="loadData()"
      width="30%"
      custom-class="pa-20"
    >
      <div class="ma-t-30">
        <div class="flex f-center">
          <div class="width30">姓名：</div>
          <el-input v-model="formData.Name" placeholder="请输入姓名"></el-input>
        </div>
        <div class="flex f-center ma-t-20">
          <div class="width30">联系电话：</div>
          <el-input
            v-model="formData.Phone"
            placeholder="请输入联系电话"
          ></el-input>
        </div>
        <div class="flex f-center ma-t-20">
          <div class="width30">网盘链接：</div>
          <el-input
            v-model="formData.diskUrl"
            placeholder="请输入网盘链接"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleApply = false">取 消</el-button>
        <el-button type="primary" @click="applyAdd()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 支付弹框二维码 -->
    <el-dialog
      :visible.sync="paydialogVisiblePay"
      width="30%"
      @before-close="paydialogVisiblePay = false"
    >
      <div>
        <payment
          :payKey="paymentKey"
          @paySuccess="paySuccess"
          v-if="paydialogVisiblePay"
        ></payment>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  PhotographerApplyGet,
  PhotographerApplyAdd,
  getuser,
  PhotographerApplyRenew,
  PhotographerApplyToPay,
} from "../api.js";
import payment from "../components/payment.vue";
export default {
  components: {
    payment,
  },
  data() {
    return {
      detail: {},
      dialogVisibleApply: false,
      paydialogVisiblePay: false,
      formData: {
        Name: "",
        Phone: "",
        diskUrl: ""
      },
      pay: {
        Amount: 0,
        Key: "",
        SN: "",
      },
      paymentKey:''
    };
  },
  created() {
    this.loadData()
    getuser().then((res) => {
      this.formData.Name = res.data.Data.Name;
      this.formData.Phone = res.data.Data.Phone;
    });
  },
  methods: {
    //获取个人支付信息
    loadData() {
      PhotographerApplyGet().then((res) => {
        this.detail = res.data.Data.Data;
        this.detail.IsJoin = res.data.Data.IsJoin;
      });
    },
    //申请加入
    applyAdd() {
      if (!this.formData.Name) {
        return this.$message.error("姓名不能为空");
      }
      if (!this.formData.Phone) {
        return this.$message.error("联系电话不能为空");
      }
      if (!this.formData.diskUrl) {
        return this.$message.error("网盘链接不能为空");
      }
      PhotographerApplyAdd(this.formData)
        .then((res) => {
          this.pay = res.data.Data;
          this.paymentKey=res.data.Data.Key;
          this.paydialogVisiblePay = true;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //支付成功
    paySuccess() {
      this.dialogVisibleApply = false;
      this.paydialogVisiblePay = false;
      this.loadData()
    },
    //已报名，未付款，去付款
    ToPay(){
        PhotographerApplyToPay({
            sn:this.detail.ToPayId
        }).then((res)=>{
            this.paymentKey=res.data.Data.Key;
            this.paydialogVisiblePay = true;
        })
    },
    //已报名，已过期，去付款
    ToPayRenew(){
        PhotographerApplyRenew({
            id:this.detail.Id
        }).then((res)=>{
            this.paymentKey=res.data.Data.Key;
            this.paydialogVisiblePay = true;

        })
    }
  },
};
</script>

<style scoped>
.btn-red {
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-size: 14px;
  background: #fb004d;
  border-radius: 5px;
}
.width28{
  width: 28%;
}
</style>